import { render, staticRenderFns } from "./CmsPage.vue?vue&type=template&id=0320067c&scoped=true&"
import script from "./CmsPage.vue?vue&type=script&lang=js&"
export * from "./CmsPage.vue?vue&type=script&lang=js&"
import style0 from "./CmsPage.vue?vue&type=style&index=0&id=0320067c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0320067c",
  null
  
)

export default component.exports